import { Injectable } from '@angular/core';
import { GeometricFormQuery } from '../../state/geometric-form.query';
import { VertexStore } from './vertex.store';
import { GeometricFormType } from '../../state/geometric-form.type';
import { Vertex, VertexClass } from './vertex.model';

@Injectable({ providedIn: 'root' })
export class VertexQuery extends GeometricFormQuery<Vertex> {

  type: GeometricFormType = 'mitra-vertex';

  invalid$ = this.selectAll({ filterBy: (v => v.invalid) });

  constructor(protected store: VertexStore) {
    super(store);
  }

  some(ids: number[], vertexClass: VertexClass): boolean {
    return ids.some(id => this.getEntity(id).vertex_class === vertexClass);
  }

  findCentralOffices(): Vertex[] {
    return this.getAll({ filterBy: v => v.vertex_class === VertexClass.CO });
  }

}
